import React from 'react';
import { ProfilePictureName } from '../../../_lib/components/ProfilePictureName';
import { InstantSubmitOrCancel } from '../../../components/organisms/InstantSubmitOrCancel/InstantSubmitOrCancel';
import { FormContainerModifier } from '../../../components/molecules/Form';
import ILink from '../../../types/ILink';
import IForm from '../../../types/IForm';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import IUrl from '../../../types/IUrl';

export type TeamRoomMemberRequestsListItem = {
  profileLink: ILink;
  profileImageUrl: ProfileImageSmall;
  personInfoCardUrl: IUrl;
  actions: { approveRequest: IForm; rejectRequest: IForm };
};

export function TeamRoomMemberRequestsListItem({
  profileLink,
  profileImageUrl,
  personInfoCardUrl,
  actions,
}: TeamRoomMemberRequestsListItem) {
  return (
    <>
      <ProfilePictureName
        profileLink={profileLink}
        profileImageUrl={profileImageUrl}
        profileName={profileLink.name}
        personInfoCardUrl={personInfoCardUrl}
      />
      <InstantSubmitOrCancel
        containerModifier={FormContainerModifier.NO_PADDING}
        transnamespace="TeamRoomMemberRequests"
        model={actions.approveRequest}
        approveAction={actions.approveRequest.url}
        rejectAction={actions.rejectRequest.url}
      />
    </>
  );
}
